import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet';
import HomePageHeroTitle from '../components/HomePage/HomePageHeroTitle';
import pagesJsonLD from '../constants/pagesJsonLD';
import './CaseStudies.css';
import './Overview.css';

const WebinarAsiaPage = () => {
  const [submitted, setSubmitted] = useState(false);
  const formId = 'rlv-banner-4c005543-1d8a-406c-972c-18e9dfac6b67';
  const buttonClass = 'releva-send-subscription';

  useEffect(() => {
    const handleButtonClick = () => {
      console.log('🔘 Submit button clicked!');
      setSubmitted(true);

      // Simulate a delay for form submission processing
      setTimeout(() => {
        const webinarForm = document.querySelector('#rlv-banner-4c005543-1d8a-406c-972c-18e9dfac6b67');
        if (webinarForm) {
          webinarForm.remove(); // Properly resets the form instead of clearing the inner HTML
          console.log('🗑️ Cleared .webinarForm');
        }
      }, 1500); // Adjust the delay as needed
    };

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          const form = document.getElementById(formId);
          const button = document.querySelector(`.${buttonClass}`);

          if (form && !form.dataset.formDetected) {
            console.log('🎉 Form appeared in the DOM!');
            form.dataset.formDetected = 'true';
          }

          if (button && !button.dataset.listenerAdded) {
            button.addEventListener('click', handleButtonClick);
            button.dataset.listenerAdded = 'true';
          }
        }
      });
    });

    const targetNode = document.body;
    observer.observe(targetNode, { childList: true, subtree: true });

    return () => observer.disconnect();
  }, []);
  return (
    <div className="overview solutions webinar">
      <Helmet>
        <title>Releva AI | Webinar</title>
        <meta
          name="description"
          content="Explore Releva AI's comprehensive overview. Learn how our AI-driven marketing platform can transform your business with personalized customer experiences, data-driven insights, and automated campaigns. Discover the future of marketing with Releva AI."
        />
        <script type="application/ld+json">{JSON.stringify(pagesJsonLD.solutionsPets)}</script>
      </Helmet>

      <div className="solutionsHero">
        <HomePageHeroTitle
          heroTitle="<h6 class='typeHolder'>Webinar</h6><h1 class='webinarTitle'></h1>"
          heroDescription="
        <div>
          <div class='webinar-cast-holder'>
            <div class='imageHolder'>
              <img src='/WebinarPages/Georgi.png' />
            </div>
            <div class='nameHolder'>
              <h4>Georgi Georgiev</h4>
              Co-founder and CEO, Releva
            </div>
          </div>
          <div class='webinar-cast-holder'>
            <div class='imageHolder'>
              <img src='/WebinarPages/Boryana.png' />
            </div>
            <div class='nameHolder'>
              <h4>Boryana Antonova</h4>
              Customer Success Director, Releva
            </div>
          </div>
        </div>
        <h2 class='dateHolder'></h2>
        <h4>The Science Behind Converting More Visitors Without Increasing Traffic</h4>
        <p><b>Discover the breakthrough methodology that's tripling conversion rates across industries without requiring more traffic or bigger budgets.</b></p>
        <p>While most marketing teams focus on driving more visitors, industry leaders are achieving exponential growth by converting existing traffic at unprecedented rates. This exclusive session reveals how Releva's AI-driven personalization and automation creates individual customer journeys that <b>convert 3x more effectively</b> than traditional approaches. Learn the exact science behind why autonomous AI consistently outperforms manual optimization and segment-based targeting.</p>
        <p>You'll learn:<p>
        <ul>
          <li>The conversion psychology: why 1:1 personalization triggers buying decisions traditional marketing cannot</li>
          <li>How AI automation eliminates the 7 most common conversion killers in real-time</li>
          <li>The compound effect: how personalization and automation multiply each other's impact</li>
          <li>Real-world case studies showing 200-400% conversion rate improvements across industries</li>
          <li>The technical framework that enables continuous conversion optimization without human intervention</li>
          <li>Why traditional A/B testing actually limits conversion potential and how AI surpasses it</li>
        <ul>"
          heroYoutube={false}
          heroLink="false"
        />
        <section className="symbol-library newWebinarPage">
          <img src="/WebinarPages/Vector.png" />

          <div className="webinarForm">
            <h4>Register for the webinar</h4>
            {submitted && (
              <>
                <p
                  style={{
                    lineHeight: '2em',
                    padding: '0 15px',
                  }}
                >
                  Thank you for signing up for our exclusive webinar! Stay ahead by adding the event to your calendar
                  now. Simply click &nbsp;
                  <a
                    target="_blank"
                    href="https://calendar.google.com/calendar/event?action=TEMPLATE&tmeid=NnVjOGhkNDRocDBjczhvczk3bHVncmIzb3UgY182YzZmMjgzYzJiNDI3NDQ1Yzc0Y2Y2NWFkNDZlMmIzY2RkZTFkMTJmMmVkYjdmNzkyZTM1MWMzOWJiZDRkYzg0QGc&tmsrc=c_6c6f283c2b427445c74cf65ad46e2b3cdde1d12f2edb7f792e351c39bbd4dc84%40group.calendar.google.com"
                  >
                    <img
                      border="0"
                      src="https://calendar.google.com/calendar/images/ext/gc_button1_en.gif"
                      alt="Google Calendar"
                    />
                  </a>
                  &nbsp; to ensure you don’t miss out on valuable insights!
                </p>
              </>
            )}
          </div>
        </section>
      </div>
    </div>
  );
};

export default WebinarAsiaPage;
